import { aggregateSparseCPU } from '../cpu';
export function sumSparseCPU(tensor, axes, keepDims) {
    return aggregateSparseCPU(tensor, axes, keepDims, (a, b) => a + b);
}
//# sourceMappingURL=cpu.js.map